module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/marquee_desktop4-74197150204cb3a160b74bd1eebe2c55.jpg";